export default __webpack_public_path__ + "static/media/installIos@2x.54bb43f3.png";